import { genericPage, getMappingProgramaSlug, getServerSidePropsHelper } from 'components/3cat/Page';
import { useRouter } from 'next/router';
import __isEmpty from 'lodash/isEmpty';
// /nom-bonic-programa/audiodescripcio
const path = ['web', process.env.FOLDER_LAYOUTS, 'programa', 'audiodescripcio'];

const Pagina = (props) => {
    const router = useRouter();
    return genericPage(props, router, path);
};

export async function getServerSideProps(context) {
    const { slug } = context.query;
    const mapping = await getMappingProgramaSlug(slug);

    if (__isEmpty(mapping) || !mapping.id) {
        return {
            notFound: true
        };
    }

    const options = {
        slugs: path,
        id: mapping.id
    };

    return getServerSidePropsHelper(context, options);
}

export default Pagina;
